var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5905 2.26471L8.70674 0.374141C8.46088 0.14237 8.13871 0.00938355 7.80152 0.000477996C7.46432 -0.00842756 7.13563 0.107369 6.87797 0.325842L0.690397 6.53575C0.468171 6.76067 0.329803 7.05546 0.298518 7.37064L0.00288956 10.2479C-0.00637188 10.349 0.00669446 10.4508 0.0411571 10.5462C0.0756197 10.6417 0.13063 10.7283 0.202267 10.7999C0.266508 10.8638 0.342694 10.9144 0.426459 10.9488C0.510223 10.9831 0.599917 11.0005 0.690397 11H0.752273L3.61918 10.7378C3.93323 10.7064 4.22696 10.5675 4.45106 10.3445L10.6386 4.13459C10.8788 3.87996 11.0086 3.54017 10.9996 3.18967C10.9905 2.83917 10.8434 2.50656 10.5905 2.26471ZM3.49543 9.35781L1.43291 9.55101L1.61853 7.48104L5.50295 3.63089L7.35922 5.49387L3.49543 9.35781ZM8.25298 4.56928L6.41046 2.72011L7.7511 1.34013L9.628 3.2238L8.25298 4.56928Z",
    fill: "#CDCEC8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.5a0bd978.svg";
export { ForwardRef as ReactComponent };